<template>
  <b-row class="flow-chart">
    <b-col>
      <dashboard-flow-chart :nodes="nodes" />
    </b-col>
  </b-row>
</template>

<script>
import DashboardFlowChart from '@/components/Dashboard/DashboardFlowChart';
import StatCircle from '@/components/Dashboard/StatCircle';
import StatBox from '@/components/Dashboard/StatBox';
import DashboardHierarchyMixin from '@/components/Dashboard/DashboardHierarchyMixin';

export default {
  name: "PropertyCountHierarchy",
  components: {
    DashboardFlowChart,
  },
  props: {
    counts: {
      type: Object,
      required: true,
    }
  },
  mixins: [DashboardHierarchyMixin],
  data() {
    return {
      nodes: [
        {
          id: "1",
          parentId: -1,
          nodeComponent: StatCircle,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            icon: 'propertymanagement',
            label: 'PROPERTIES IN JOBS',
            labelClass: 'text-dark',
            to: {
              name: 'programme',
              query: { assessmentStatus: [
                'Submitted for Validation',
                'Stage 1 Check Complete',
                'Stage 2 Check Complete',
                'Returned from Validation',
                'Finalised',
                'Rolled Back',
                'Assigned',
                'Inspection Started',
                'Inspection Paused',
                'Inspection Finished',
                'Being Written Up',
                'Queried',
                'Unassigned',
                'No Access',
                ]
              },
              params: {title: 'Properties in Jobs'},
            },
          },
        },
        {
          id: "2",
          parentId: "1",
          nodeComponent: StatCircle,
          data: {
            value: 0,
            color: '#FFFFFF',
            bgColor: "#638BC2",
            label: 'VALIDATION',
            to: {
              name: 'programme',
              query: {
                assessmentStatus: [
                  'Submitted for Validation',
                  'Stage 1 Check Complete',
                  'Stage 2 Check Complete',
                  'Returned from Validation',
                  'Finalised',
                  'Rolled Back',
                ]
              },
              params: { title: 'Validation' },
            },
          },
        },
        {
          id: "3",
          parentId: "1",
          nodeComponent: StatCircle,
          data: {
            value: 0,
            color: '#FFFFFF',
            bgColor: "#678DA9",
            label: 'IN PROGRESS',
            to: {
              name: 'programme',
              query: {
                assessmentStatus: [
                  'Assigned',
                  'Appointment Booked',
                  'Inspection Started',
                  'Inspection Paused',
                  'Inspection Finished',
                  'Being Written Up',
                ]
              },
              params: { title: 'In Progress' },
            },
          },
        },
        {
          id: "4",
          parentId: "1",
          nodeComponent: StatCircle,
          data: {
            value: 0,
            color: '#FFFFFF',
            bgColor: "#FFA600",
            label: 'QUERIED',
            to: {
              name: 'programme',
              query: {
                queryType: [
                  'No Access',
                  'Void',
                  'Contact Unresponsive',
                  'Other',
                ],
              },
              params: { title: 'Queried' },
            },
          },
        },
        {
          id: "5",
          parentId: "1",
          nodeComponent: StatCircle,
          data: {
            value: 0,
            color: '#FFFFFF',
            bgColor: "#E87D5C",
            label: 'UNASSIGNED',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Unassigned' },
            },
          },
        },
        {
          id: "submitted for validation",
          parentId: "2",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'SUBMITTED FOR VALIDATION',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Submitted for Validation' },
            },
          },
        },
        {
          id: "stage 1 check complete",
          parentId: "submitted for validation",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'STAGE ONE CHECKED',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Stage 1 Check Complete' },
            },
          },
        },
        {
          id: "stage 2 check complete",
          parentId: "stage 1 check complete",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'STAGE TWO CHECKED',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Stage 2 Check Complete' },
            },
          },
        },
        {
          id: "returned from validation",
          parentId: "stage 2 check complete",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'RETURNED FROM VALIDATION',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Returned from Validation' },
            },
          },
        },
        {
          id: "finalised",
          parentId: "returned from validation",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'FINALISED',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Finalised' },
            },
          },
        },
        {
          id: "rolled back",
          parentId: "finalised",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#EFF3F8",
            label: 'ROLLED BACK',
            labelColor: '#2C3E38',
            color: '#638BC2',
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Rolled Back' },
            },
          },
        },
        {
          id: "assigned",
          parentId: "3",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'ASSIGNED',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Assigned' },
            },
          },
        },
        {
          id: "appointment booked",
          parentId: "assigned",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'APPOINTMENT BOOKED',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Appointment Booked' },
            },
          },
        },
        {
          id: "inspection started",
          parentId: "appointment booked",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'INSPECTION STARTED',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Inspection Started' },
            },
          }
        },
        {
          id: "inspection paused",
          parentId: "inspection started",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'INSPECTION PAUSED',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Inspection Paused' },
            },
          }
        },
        {
          id: "inspection finished",
          parentId: "inspection paused",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'INSPECTION FINISHED',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Inspection Finished' },
            },
          },
        },
        {
          id: "being written up",
          parentId: "inspection finished",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#F2F5F8",
            label: 'BEING WRITTEN UP',
            labelColor: '#2C3E38',
            color: "#678DA9",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { assessmentStatus: 'Being Written Up' },
            },
          },
        },
        {
          id: "no access",
          parentId: "4",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#FFF6E5",
            label: 'NO ACCESS',
            labelColor: '#2C3E38',
            color: "#FFA600",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { queryType: 'No Access' },
            },
          },
        },
        {
          id: "void",
          parentId: "no access",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#FFF6E5",
            label: 'VOID',
            labelColor: '#2C3E38',
            color: "#FFA600",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { queryType: 'Void' },
            },
          },
        },
        {
          id: "contact unresponsive",
          parentId: "void",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#FFF6E5",
            label: 'CONTACT UNRESPONSIVE',
            labelColor: '#2C3E38',
            color: "#FFA600",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { queryType: 'Contact Unresponsive' },
            },
          },
        },
        {
          id: "other",
          parentId: "contact unresponsive",
          nodeComponent: StatBox,
          data: {
            value: 0,
            bgColor: "#FFF6E5",
            label: 'OTHER',
            labelColor: '#2C3E38',
            color: "#FFA600",
            align: "center",
            size: "x-small",
            cssClass: 'py-1 stat-box',
            to: {
              name: 'programme',
              query: { queryType: 'Other' },
            },
          },
        },
      ],
    };
  },
  computed: {
    total() {
      if (!this.counts) {
        return 0;
      }

      const { assessmentStatus } = this.counts;
      return this.validation + this.inProgress + this.queried + assessmentStatus['unassigned'];
    },
    validation() {
      if (!this.counts) {
        return 0;
      }

      const { assessmentStatus } = this.counts;

      return assessmentStatus['submitted for validation']
          + assessmentStatus['stage 1 check complete']
          + assessmentStatus['stage 2 check complete']
          + assessmentStatus['returned from validation']
          + assessmentStatus['finalised']
          + assessmentStatus['rolled back'];
    },
    inProgress() {
      if (!this.counts) {
        return 0;
      }

      const { assessmentStatus } = this.counts;

      return assessmentStatus['assigned']
        + assessmentStatus['appointment booked']
        + assessmentStatus['inspection started']
        + assessmentStatus['inspection paused']
        + assessmentStatus['inspection finished']
        + assessmentStatus['being written up'];
    },
    queried() {
      const { queried } = this.counts;

      return queried['no access']
        + queried['void']
        + queried['contact unresponsive']
        + queried['other'];
    }
  },
  created() {
    this.updateCounts();
  },
  methods: {
    updateCounts() {

      const { assessmentStatus, queried } = this.counts;

      // Level 1
      this.nodes[0].data.value = this.total;

      // Level 2
      this.nodes[1].data.value = this.validation;
      this.nodes[2].data.value = this.inProgress;
      this.nodes[3].data.value = this.queried;
      this.nodes[4].data.value = assessmentStatus['unassigned'];

      // Level 3
      this.updateValue('submitted for validation', assessmentStatus['submitted for validation']);
      this.updateValue('stage 1 check complete', assessmentStatus['stage 1 check complete']);
      this.updateValue('stage 2 check complete', assessmentStatus['stage 2 check complete']);
      this.updateValue('returned from validation', assessmentStatus['returned from validation']);
      this.updateValue('finalised', assessmentStatus['finalised']);
      this.updateValue('rolled back', assessmentStatus['rolled back']);

      this.updateValue('assigned', assessmentStatus['assigned']);
      this.updateValue('appointment booked', assessmentStatus['appointment booked']);
      this.updateValue('inspection started', assessmentStatus['inspection started']);
      this.updateValue('inspection paused', assessmentStatus['inspection paused']);
      this.updateValue('inspection finished', assessmentStatus['inspection finished']);
      this.updateValue('being written up', assessmentStatus['being written up']);

      this.updateValue('no access', queried['no access']);
      this.updateValue('void', queried['void']);
      this.updateValue('contact unresponsive', queried['contact unresponsive']);
      this.updateValue('other', queried['other']);

      this.filterHierarchy('submitted for validation');
      this.filterHierarchy('assigned');
      this.filterHierarchy('no access');

    },
  }
}
</script>

<style scoped>

</style>
